import type { ProcessFlowProcess } from '@/@types/ProcessFlow';
import type { RequestState } from '../../@types/RequestState';
import useProcesses from './useProcesses';

const useActivePurchaseProcesses = (): [ProcessFlowProcess[] | undefined, RequestState] => {
  const [processes, requestProcesses] = useProcesses();

  return [
    processes?.filter((x) => x.tags.includes('purchase') && x.configuration.isActive),
    requestProcesses,
  ];
};

export default useActivePurchaseProcesses;
